/**
 * Shared inspection-status utility module.
 * Single source of truth for airworthiness status calculation,
 * matching legacy behavior (hangars.js, aircraft-dialog.js, resource-details.js).
 */

/**
 * The API sends flags as a legacy '1'/1 or as a Symfony boolean.
 * Only true, 1 and '1' are truthy; everything else is false.
 */
const isFlagSet = value => value === true || value === 1 || value === '1';

/** Normalize the affectsAirworthiness value from the API. */
export const normalizeAffectsAirworthiness = isFlagSet;

/** Check if an inspection is overdue (danger status). */
export const isInspectionOverdue = inspection => isFlagSet(inspection.danger);

/** Check if an inspection is inside a notification window (warning status). */
export const isInspectionWarning = inspection => isFlagSet(inspection.warning);

/**
 * Get airworthiness status from inspections array.
 * Legacy parity:
 * - 'unknown'      when inspections.length === 0
 * - 'airworthy'    when inspections exist and no airworthiness+danger inspection found
 * - 'unairworthy'  when at least one inspection with affectsAirworthiness is overdue
 */
export const getAirworthinessStatusFromInspections = inspections => {
	if (!inspections || inspections.length === 0) {
		return 'unknown';
	}

	for (let i = inspections.length - 1; i >= 0; i--) {
		if (
			isInspectionOverdue(inspections[i]) &&
			normalizeAffectsAirworthiness(inspections[i].affectsAirworthiness)
		) {
			return 'unairworthy';
		}
	}

	return 'airworthy';
};
